"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function mco(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.985 3.75677L19.125 7.86903V16.119L11.9932 20.2433L11.9355 20.229L4.875 16.119V7.86903L11.9355 3.75677H11.985ZM11.9618 4.61027L5.625 8.30027V15.6878L11.961 19.377L12.735 18.9293L18.375 15.6855V8.30177L12.735 5.03927L11.9618 4.61027ZM6.60675 12.5678L8.4825 11.1653L10.1407 12.2243V14.1293L11.3955 15.3383L11.3947 15.9053L10.1858 17.0378H9.165L6.6075 12.5678H6.60675ZM12.534 15.9068L12.5317 15.3368L13.782 14.1293V12.2243L15.4222 11.1518L17.2943 12.5685L14.7495 17.025H13.7415L12.534 15.9068ZM10.7565 12.2243L10.146 10.626H13.7745L13.176 12.2243L13.353 14.0108L11.9528 14.0138L10.569 14.016L10.7565 12.2243ZM11.9528 10.188L8.50425 10.1865L9.1455 7.32152H14.7435L15.4185 10.1903L11.9528 10.188Z", fill: color }));
}
exports["default"] = mco;
//# sourceMappingURL=mco.js.map